// extracted by mini-css-extract-plugin
export default {"container":"hackathon_container__EEv+2","mainbg":"hackathon_mainbg__AV6bg","gradientbg":"hackathon_gradientbg__KQdNS"};